import { useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { resolveImageUrl } from "../pages/admin/ImagePicker";

export default function BeforeAfterSlider({ item, en = false }) {
  const [pos, setPos] = useState(50);
  const before = en ? "Before" : "Avant";
  const after = en ? "After" : "Après";
  return (
    <div className="relative aspect-[4/3] overflow-hidden rounded-t-3xl bg-[#E8F5E9] select-none">
      <img
        src={resolveImageUrl(item.after_url)}
        alt={`${after} — ${item.title}`}
        width="800"
        height="600"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <img
        src={resolveImageUrl(item.before_url)}
        alt={`${before} — ${item.title}`}
        width="800"
        height="600"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />
      <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-black/60 text-white text-xs font-semibold uppercase tracking-wider">{before}</span>
      <span className="absolute top-3 right-3 px-3 py-1 rounded-full bg-[#1B5E20] text-white text-xs font-semibold uppercase tracking-wider">{after}</span>
      <div className="absolute inset-y-0 w-0.5 bg-white shadow pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center">
          <MoveHorizontal className="w-5 h-5 text-[#1B5E20]" />
        </div>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label={`Comparer avant et après — ${item.title}`}
        data-testid={`before-after-range-${item.id}`}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
      />
    </div>
  );
}
